import {store} from '..';
import {isAvailabiltyRoute, isRescheduleRoute} from '../../utils/isRoute';
import {
  dateSelectAvailability,
  employeeMultiSelectAvailability,
  employeeSelectAvailability,
  fetchApiAvailability,
  startTimeSelectAvailability,
} from './availability/slice';
import {ANY_EMPLOYEE} from './constants';
import {TimeSelectAction} from './reducers';
import {
  dateSelectReschedule,
  employeeMultiSelectReschedule,
  employeeSelectReschedule,
  fetchApiRescheduleAvailability,
  startTimeSelectReschedule,
} from './reschedule/slice';

export const dispatchDateSelect = ({
  date,
  startTime = null,
  hasDiscount = false,
  totalPrice = '',
  originalPrice = '',
}: {
  date: string;
} & Partial<TimeSelectAction>) => {
  if (isAvailabiltyRoute()) {
    store.dispatch(
      dateSelectAvailability({
        date,
        startTime,
        hasDiscount,
        totalPrice,
        originalPrice,
      }),
    );
  }

  if (isRescheduleRoute()) {
    store.dispatch(
      dateSelectReschedule({
        date,
        startTime,
        hasDiscount,
        totalPrice,
        originalPrice,
      }),
    );
  }
};

export const dispatchStartTimeSelect = ({
  startTime,
  hasDiscount,
  totalPrice,
  originalPrice,
}: TimeSelectAction) => {
  if (isAvailabiltyRoute()) {
    store.dispatch(
      startTimeSelectAvailability({
        startTime,
        hasDiscount,
        totalPrice,
        originalPrice,
      }),
    );
  }

  if (isRescheduleRoute()) {
    store.dispatch(
      startTimeSelectReschedule({
        startTime,
        hasDiscount,
        totalPrice,
        originalPrice,
      }),
    );
  }
};

export const dispatchFetchAvailability = ({
  startDate,
}: {
  startDate: string | null;
}) => {
  if (isAvailabiltyRoute()) {
    return store.dispatch(
      fetchApiAvailability({url: location.href, startDate}),
    );
  }

  return store.dispatch(
    fetchApiRescheduleAvailability({url: location.href, startDate}),
  );
};

export const dispatchEmployeeSelect = (employeeId: string) => {
  if (isAvailabiltyRoute()) {
    store.dispatch(
      employeeSelectAvailability(
        employeeId === ANY_EMPLOYEE ? ANY_EMPLOYEE : Number(employeeId),
      ),
    );
  }

  if (isRescheduleRoute()) {
    store.dispatch(
      employeeSelectReschedule(
        employeeId === ANY_EMPLOYEE ? ANY_EMPLOYEE : Number(employeeId),
      ),
    );
  }
};

export const dispatchMultiEmployeeSelect = ({
  menuItemId,
  employeeId,
}: {
  menuItemId: string;
  employeeId: string;
}) => {
  if (isAvailabiltyRoute()) {
    store.dispatch(
      employeeMultiSelectAvailability({
        menuItemId,
        employeeId:
          employeeId === ANY_EMPLOYEE ? undefined : Number(employeeId),
      }),
    );
  }

  if (isRescheduleRoute()) {
    store.dispatch(
      employeeMultiSelectReschedule({
        menuItemId,
        employeeId:
          employeeId === ANY_EMPLOYEE ? undefined : Number(employeeId),
      }),
    );
  }
};
